export default __webpack_public_path__ + "static/media/cloud-computing.319e3ab6.svg";